// extracted by mini-css-extract-plugin
export var card = "_v3-0";
export var details = "_v3-1";